<template>
    <AdminSelect v-model="modelValue" :options="types" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

const modelValue = defineModel({
    type: String,
});

const types = ref([]);

const loadProducts = async () => {
    axios.get(route('delivery/delivery-ppl/products.admin.api.all')).then(({ data }) => {
        types.value = data.data.map((type: any) => ({
            id: type.code,
            name: `${type.code} - ${type.name}`,
        }));
    });
};

onMounted(() => {
    loadProducts();
});
</script>
